import { useStyletron } from "baseui";
import { SIZE, StyledSpinnerNext } from "baseui/spinner";
import React, { useEffect, useState } from "react";
import { StyleObject } from "styletron-standard";

export const Spin = () => <StyledSpinnerNext $size={SIZE.large} />;

export const MediumSpin = (props: { $style?: StyleObject }) => (
  <StyledSpinnerNext
    $style={{
      width: "20px",
      height: "20px",
      ...props.$style,
    }}
    $size={SIZE.medium}
  />
);

export const SmallSpin = (props: { $style?: StyleObject }) => (
  <StyledSpinnerNext
    $style={{
      width: "14px",
      height: "14px",
      ...props.$style,
    }}
    $size={SIZE.small}
  />
);

const DotCount = 3;
const SpinTime = 1800;

export const EllipsisSpin = () => {
  const [css, $theme] = useStyletron();
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prevCount) => (prevCount + 1) % DotCount);
    }, SpinTime / DotCount);

    return () => clearInterval(interval);
  }, []);

  return (
    <span
      className={
        "ellipsis-spin " +
        css({
          display: "inline-block",
          width: "20px",
        })
      }
    >
      {".".repeat(dotCount)}
    </span>
  );
};

export const ShimmeringText = (props: JSX.IntrinsicElements["div"] & { $style?: StyleObject }) => {
  const [css, $theme] = useStyletron();

  return (
    <div
      {...props}
      className={css({
        display: "inline-block",
        background: `linear-gradient(
          90deg,
          ${$theme.colors.alpha400} 0%,
          ${$theme.colors.primary} 50%,
          ${$theme.colors.alpha400} 100%
        )`,
        backgroundSize: "200% 100%",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        color: "transparent",
        animation: `shimmer ${SpinTime * 2}ms infinite linear`,
        "@keyframes shimmer": {
          "0%": {
            backgroundPosition: "200% 0",
          },
          "100%": {
            backgroundPosition: "-200% 0",
          },
        },
        ...props.$style,
      })}
    />
  );
};
